import SubContainer from '@/components/Container/SubContainer';
import StatsAndStreakProfile from '@/components/StatsAndStreakProfile';
import { FetchUserStreakQuery, FetchUserStreakQueryVariables } from '@/graphql/generated/graphql';
import { QUERY_FETCH_USER_STREAK } from '@/graphql/queries/daily/completed-tasks';
import { getUserTrackingData } from '@/services/daily/complete-tasks.service';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useProfileStore } from '../store/useProfileStore';

export const ProfileStreak = () => {
  const { page } = useProfileStore();

  const { data: emotionWheelData } = useQuery<FetchUserStreakQuery, FetchUserStreakQueryVariables>(
    QUERY_FETCH_USER_STREAK,
    {
      variables: {
        type: 'EMOTIONAL_WHEEL',
      },
    },
  );

  const { data: insightData } = useQuery<FetchUserStreakQuery, FetchUserStreakQueryVariables>(QUERY_FETCH_USER_STREAK, {
    variables: {
      type: 'INSIGHT',
    },
  });

  const { data: mindfulMinuteData } = useQuery<FetchUserStreakQuery, FetchUserStreakQueryVariables>(
    QUERY_FETCH_USER_STREAK,
    {
      variables: { type: 'MINDFUL_MINUTE' },
    },
  );

  const [data, setData] = useState<{
    dailyStreak: number;
    streakRecord: number;
  }>({
    dailyStreak: 0,
    streakRecord: 0,
  });
  useEffect(() => {
    (async () => {
      const response = await getUserTrackingData();
      const { dailyStreak, streakRecord } = response.data?.getUserTrackingData || {};

      setData({
        dailyStreak: dailyStreak || 0,
        streakRecord: streakRecord || 0,
      });
    })();
  }, []);

  return (
    <SubContainer className="grid grid-cols-12 md:grid-cols-5 lg:!col-start-3 lg:!col-end-11 lg:mb-16">
      <StatsAndStreakProfile
        type="STREAK"
        color="EMOTION_WHEEL"
        title={page?.statsAndStreaks?.finishingCardStreak?.title || 'Your current streak'}
        unit={page?.statsAndStreaks?.finishingCardStreak?.days || 'Days'}
        value={data.dailyStreak}
      />
      <StatsAndStreakProfile
        type="STREAK"
        color="EMOTION_WHEEL"
        title={page?.statsAndStreaks?.finishingCardMaxStreak?.title || 'Your current streak'}
        unit={page?.statsAndStreaks?.finishingCardMaxStreak?.days || 'Days'}
        value={data.streakRecord}
      />
      <StatsAndStreakProfile
        type="EMOTION_WHEEL"
        value={emotionWheelData?.fetchUserStreak?.total || 0}
        unit={page?.statsAndStreaks?.finishingCardEmotionWheel?.emotions || 'Emotions'}
        title={''}
        color="EMOTION_WHEEL"
      />
      <StatsAndStreakProfile
        color="INSIGHT"
        type="INSIGHT"
        value={insightData?.fetchUserStreak?.total || 0}
        unit={page?.statsAndStreaks?.finishingCardInsight?.insights || 'Insights'}
        title={''}
      />
      <StatsAndStreakProfile
        type="MINDFUL"
        value={mindfulMinuteData?.fetchUserStreak?.total || 0}
        unit={page?.statsAndStreaks?.finishingCardMindfulMinute?.minutes || 'Mindful minutes'}
        title={''}
        color="MINDFUL"
      />
    </SubContainer>
  );
};
